<template>
  <div>
    <el-form
      ref="applyForm"
      :model="applyForm"
      :rules="applyRules"
      label-width="120px"
      label-position="left"
      :disabled="readOnly"
      v-loading="searchLoading">
      <el-form-item label="开票金额" v-if="!auto">
        <span>{{ parseFloat(applyForm.fAmount / 100).toFixed(2) }}元</span>
        <span v-if="applyForm.fFeeDetail">（{{ applyForm.fFeeDetail }}）</span>
      </el-form-item>
      <el-form-item label="商户编号" v-if="auto" prop="fMerchantId">
        <el-input v-model="applyForm.fMerchantId" placeholder="请输入商户编号" class="form-input" :disabled="this.selectedRow && JSON.stringify(this.selectedRow) !== '{}'" @input="clearSamesubjectList(type = 'merchantId')"></el-input>
        <el-button type="text" v-show="isSameSubject && auto" class="searchLink" @click="searchSub" :loading="subjectSearchLoading">查询同主体商户</el-button>
      </el-form-item>
      <el-form-item label="同主体商户" v-if="auto && isSameSubject" prop="multiMerchantIdString">
        <el-transfer class="transfer" v-model="applyForm.multiMerchantIdString" :data="sameSubjectList" :titles="['可选', '已选']" :render-content="renderFunc">
          <span slot-scope="{ option }" :title="option.label">{{ option.label }}</span>
        </el-transfer>
      </el-form-item>
      <el-form-item label="费用类型" v-if="auto">
        <el-select v-model="applyForm.fFeeType" @change="clearSamesubjectList(type = 'feeType')">
          <el-option :value="0" label="交易手续费"></el-option>
          <el-option :value="2" label="花呗贴息费"></el-option>
          <el-option :value="1" label="其它"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发票类型">
        <el-select v-model="applyForm.fInvoiceType" @change="setInvoiceType">
          <el-option :value="0" label="普通增值税发票"></el-option>
          <el-option :value="1" label="专用增值税发票"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="一般纳税人证明" label-width="130px" prop="fTaxpayerPic" v-show="applyForm.fInvoiceType === 1">
        <upload-img-ele
          valueName="applyForm.fTaxpayerPic"
          v-model="applyForm.fTaxpayerPic"
          :value="applyForm.fTaxpayerPic"
          :disabled="readOnly"
          @upload="uploadSuccess"></upload-img-ele>
      </el-form-item>
      <el-form-item label="开票抬头" prop="fInvoiceTitle">
        <el-autocomplete
          class="form-input"
          clearable
          v-model="applyForm.fInvoiceTitle"
          :fetch-suggestions="remoteMethod"
          placeholder="请输入开票抬头，一般为商户营业执照名称"
          :trigger-on-focus="false"
          @select="handleSelect"
        ></el-autocomplete>
        <auth-button opt="get_last_apply_record" type="text" @click.native="getLastApplyRecord" label="填充上次开票信息"></auth-button>
      </el-form-item>
      <el-form-item label="纳税人识别号" prop="fTaxpayerNum">
        <el-input v-model.trim="applyForm.fTaxpayerNum" class="form-input" placeholder="请输入统一社会信用代码" clearable></el-input>
        <auth-button opt="accurate_query" type="text" @click.native="accurateQuery" label="精确查询"></auth-button>
        <span class="grey">(查询后自动填充相关信息)</span>
      </el-form-item>
      <el-form-item label="注册地址" prop="fRegisterAddress" :required="applyForm.fInvoiceType === 1">
        <el-input v-model="applyForm.fRegisterAddress" @change="handleAddressChange" class="form-input" placeholder="请输入营业执照注册地址"></el-input>
        <div v-if="needIntercept">注册地址过长，将按要求自动截取显示在发票中</div>
      </el-form-item>
      <el-form-item label="登记电话" prop="fPhone" :required="applyForm.fInvoiceType === 1">
        <el-input v-model="applyForm.fPhone" @input="handlePhoneChange" class="form-input" placeholder="请输入在税务机关登记的电话号码"></el-input>
      </el-form-item>
      <el-form-item label="开户账号" prop="fBankAccount" :required="applyForm.fInvoiceType === 1">
        <el-input v-model="applyForm.fBankAccount" class="form-input" placeholder="请输入企业基本开户账号"></el-input>
      </el-form-item>
      <el-form-item label="开户行" prop="fBankName" :required="applyForm.fInvoiceType === 1">
        <el-input v-model="applyForm.fBankName" class="form-input" placeholder="请输入具体的开户行信息，包括支行网点"></el-input>
      </el-form-item>
      <el-form-item label="收件人手机号" v-show="applyForm.fInvoiceType === 0" :required="applyForm.fInvoiceType === 0">
        <el-form-item prop="fReceivePhone">
          <el-input v-model="applyForm.fReceivePhone" class="form-input" placeholder="请输入收件人手机号码"></el-input>
        </el-form-item>
      </el-form-item>
      <el-form-item label="收件人邮箱" v-if="applyForm.fInvoiceType === 0">
        <el-input v-model="applyForm.fReceiveEmail" class="form-input" placeholder="收件人邮箱"></el-input>
      </el-form-item>
      <el-form-item label="附加说明" prop="fRemark" v-if="showInvoiceRemark">
        <el-input v-model="applyForm.fRemark" type="textarea" :rows="2" placeholder="请输入附加说明"></el-input>
      </el-form-item>
      <el-form-item label="发票备注" prop="fMessage">
        <el-input v-model="applyForm.fMessage" type="textarea" :rows="2" placeholder="请输入发票备注"></el-input>
      </el-form-item>
      <p class="tips">此发票备注信息会打印到发票的备注栏中，请谨慎填写</p>
      <p class="ml120" v-if="applyForm.fInvoiceType === 1">（专用增值税发票只有纸质发票；默认统一寄送至代理商地址，请正确填写）</p>
      <el-form-item label="开票方式" prop="fIssueInvoiceType" v-if="auto" style="margin-top: 24px;">
        <el-radio-group v-model="applyForm.fIssueInvoiceType">
          <el-radio style="display:block; margin-bottom: 10px;" :label="0">合并开票(同商户多条可开票信息，合并为一条申请记录)</el-radio>
          <el-radio style="display:block;" :label="1">逐月开票</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="自动申请时间" prop="fApplyTime" v-if="auto">
        每月
        <el-select v-model="applyForm.fApplyTime" placeholder="" style="width: 70px;">
          <el-option v-for="item in invoiceTimeList" :key="item" :value="item" :label="item"></el-option>
        </el-select>
        号 (每月15号前的开票申请当月处理，15号之后的开票申请次月处理)
      </el-form-item>
    </el-form>
    <el-button class="submitBtn" type="primary" @click="submit" :loading="submitLoading" v-if="!readOnly">确认</el-button>
  </div>
</template>

<script>
import qs from 'qs'
import uploadImgEle from '@/components/upload/uploadImgEle'
import { dimQuery, accurateQuery, getLastApplyRecord, listAutoInvoiceMulti } from '@/api/settle'
export default {
  name: 'ApplyForm',
  components: {
    uploadImgEle
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false
    },
    // 发票详情表单
    formData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    submitLoading: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    amount: {
      type: String,
      default: ''
    },
    ids: {
      type: Array,
      default () {
        return []
      }
    },
    desc: {
      type: String,
      default: ''
    },
    showInvoiceRemark: {
      type: Boolean,
      default: false
    },
    selectedMerchantId: {
      type: String,
      default: ''
    },
    auto: {
      type: Boolean,
      default: false
    },
    selectedRow: {
      type: Object,
      default: () => {}
    },
    // 同主体开票
    isSameSubject: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      applyForm: {
        fId: '', // 记录编号
        fInvoiceId: [], // 选中的发票记录
        fAmount: 0, // 金额
        fFeeDetail: '', // 费用明细
        fInvoiceType: 0, // 发票类型，0普通增值税发票，1专用增值税发票
        fTaxpayerPic: '', // 一般纳税人证明
        fInvoiceTitle: '', // 发票抬头
        fTaxpayerNum: '', // 纳税人识别号
        fRegisterAddress: '', // 注册地址
        fPhone: '', // 登记电话
        fBankAccount: '', // 开户账号
        fBankName: '', // 开户行
        fReceivePhone: '', // 收件人手机号
        fReceiveEmail: '', // 收件人邮箱
        fInvoiceRemark: '', // 附加说明
        fRemark: '', // 附加说明
        fMessage: '', // 发票备注
        fIssueInvoiceType: 0, // 开票类型 0-合并开票 1-逐月开票 默认合并开票
        fApplyTime: 5, // 开票时间 1~28 默认5号
        fMerchantId: '',
        fFeeType: 0,
        multiMerchantIdString: []
      },
      options: [],
      txt: '',
      applyRules: {
        fMerchantId: [
          { required: this.auto, message: '请输入商户编号', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (this.auto && !value) {
                callback(new Error('请输入商户编号'))
              }
              if (this.auto && !/^[\d]{10}$/.test(value)) {
                callback(new Error('请输入正确商户编号'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        multiMerchantIdString: [
          { required: this.auto, message: '请选择同主体商户', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (this.auto && (!value || !value.length)) {
                callback(new Error('请选择同主体商户'))
              } else if (this.auto && value.length > 500) {
                callback(new Error('自动开票配置同主体商户仅支持500个以内'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        fInvoiceTitle: [
          { required: true, message: '请输入开票抬头', trigger: 'blur' }
        ],
        fTaxpayerNum: [
          { required: true, message: '请输入纳税人识别号', trigger: 'blur' }
        ],
        fTaxpayerPic: [{
          validator: (rule, value, callback) => {
            if (this.applyForm.fInvoiceType === 1 && value === '' && !this.readOnly) {
              callback(new Error('请上传一般纳税人证明图片'))
            } else {
              callback()
            }
          },
          required: true,
          trigger: 'change'
        }],
        fRegisterAddress: [{
          validator: (rule, value, callback) => {
            if (this.applyForm.fInvoiceType === 1 && value === '' && !this.readOnly) {
              callback(new Error('请输入营业执照注册地址'))
            } else {
              callback()
            }
          },
          required: false,
          trigger: 'blur'
        }],
        fPhone: [{
          validator: (rule, value, callback) => {
            if (this.applyForm.fInvoiceType === 1 && value === '' && !this.readOnly) {
              callback(new Error('请输入在税务机关登记的电话号码'))
            } else {
              callback()
            }
          },
          required: false,
          trigger: 'blur'
        }],
        fBankAccount: [{
          validator: (rule, value, callback) => {
            if (this.applyForm.fInvoiceType === 1 && value === '' && !this.readOnly) {
              callback(new Error('请输入企业基本开户账号'))
            } else {
              callback()
            }
          },
          required: false,
          trigger: 'blur'
        }],
        fBankName: [{
          validator: (rule, value, callback) => {
            if (this.applyForm.fInvoiceType === 1 && value === '' && !this.readOnly) {
              callback(new Error('请输入具体的开户行信息，包括支行网点'))
            } else {
              callback()
            }
          },
          required: false,
          trigger: 'blur'
        }],
        fReceivePhone: [{
          validator: (rule, value, callback) => {
            if (this.applyForm.fInvoiceType === 0 && !(/^\d{11,11}$/.test(value)) && ((!value.includes('*') && this.isEdit) || !this.isEdit)) {
              callback(new Error('请输入11位收件人手机号码'))
            } else {
              callback()
            }
          },
          required: true,
          trigger: 'blur'
        }],
        fMessage: [{
          validator: (rule, value, callback) => {
            if (!value) {
              callback()
            }
            if (/\n/.test(value)) {
              callback(new Error('请输入正确的备注信息'))
            } else if (value.replace(/[\u4E00-\u9FA5]/g, '01').length > 230) {
              callback(new Error('备注信息不能超过230个字符'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }]
      },
      bankListReq: {
        bankName: ''
      }, // 银行列表请求数据，本来可以为空对象，但是为了获取初始列表
      bankTypeError: false,
      lumhBankCardId: '',
      needIntercept: false, // 注册地址是否需要裁剪
      interceptAddress: '',
      searchLoading: false,
      invoiceTimeList: [...Array(28)].map((item, index) => {
        return index + 1
      }),
      subjectSearchLoading: false,
      sameSubjectList: []
    }
  },
  watch: {
    visible (val) {
      // 弹窗隐藏时清空内容
      if (!val) {
        this.applyForm = this.$options.data().applyForm
        this.sameSubjectList = []
      } else {
        this.$refs.applyForm.clearValidate()
        this.initInfo()
      }
    }
  },
  created () {
    this.roleId = this.$store.getters.roleId
    this.initInfo()
  },
  methods: {
    initInfo () {
      if (JSON.stringify(this.formData) !== '{}') {
        this.applyForm = this.formData
      } else {
        this.applyForm.fInvoiceId = this.ids
        this.applyForm.fAmount = this.amount
        this.applyForm.fFeeDetail = this.desc
      }
      if (this.selectedRow && JSON.stringify(this.selectedRow) !== '{}') {
        this.setModuleInfo(this.applyForm, this.selectedRow)
      }
      if (this.auto && this.isSameSubject && this.selectedRow && JSON.stringify(this.selectedRow) !== '{}') {
        this.searchSub()
      }
    },
    /**
         * @description 表单校验
         */
    submit () {
      if (!this.checkFormInfo()) return
      const applyForm = JSON.parse(JSON.stringify(this.applyForm))
      applyForm.multiMerchantIdString = applyForm.multiMerchantIdString.toString()
      applyForm.fMultiFlag = this.isSameSubject ? 1 : 0
      if (this.needIntercept) {
        applyForm.fRegisterAddress = this.interceptAddress
      }
      this.$emit('submit', applyForm)
    },
    /**
         * @description 删除对象中字符串的空格
         * @param  {number} params 目标对象
         */
    dismissBlank (params) {
      for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key)) {
          const element = params[key]
          if (typeof element === 'string') {
            params[key] = element.replace(/ /g, '')
          }
        }
      }
      return params
    },
    /**
         * @description 校验表单信息
         */
    checkFormInfo () {
      let formvalid = false
      // let bankBranchValid = false;
      this.$refs.applyForm.validate((valid, error) => {
        formvalid = valid
        return valid
      })
      if (!formvalid) {
        this.$message({
          message: this.auto ? '自动开票配置信息有误，请完善后提交' : '开票信息有误，请完善后提交',
          type: 'warning'
        })
        return false
      }
      return true
    },
    /**
         * @description 选择发票类型
         */
    setInvoiceType (value) {
      if (this.auto) {
        const merchantId = this.applyForm.fMerchantId
        const feeType = this.applyForm.fFeeType
        const id = this.applyForm.fId
        // const merchantId = this.applyForm.fMerchantId
        this.applyForm = this.$options.data().applyForm
        this.applyForm.fMerchantId = merchantId
        this.applyForm.fFeeType = feeType
        this.applyForm.fId = id
      } else {
        this.applyForm = this.$options.data().applyForm
      }
      // 切换类型时清空一般纳税证明图片
      this.applyForm.fInvoiceType = value
      this.applyForm.fInvoiceId = this.ids
      this.applyForm.fAmount = this.amount
      this.applyForm.fFeeDetail = this.desc
      setTimeout(() => {
        this.$refs.applyForm.clearValidate()
      }, 100)
    },
    /**
         * @description 图片上传成功的回调
         */
    uploadSuccess (data) {
      if (data.error_code === '0') {
        this.applyForm.fTaxpayerPic = data.path
      }
    },
    /**
         * @description 银行分行选中回调
         * @param {Object} val 组件传的参数，分行选中数据
         */
    getBankBranch (val) {
      this.applyForm.fBankCode = val.bankNameCode// 银行类型编码
      this.applyForm.fBankCity = val.bankCityCode// 银行类型编码
      this.applyForm.fBankProvince = val.bankAreaCode// 银行类型编码
      this.applyForm.fBankBranch = val.bankBranchCode// 分行id
    },
    /**
         * @description 银行分行联动银行错误回调
         * @param {Object} value 组件传的参数，银行名称是否错误
         */
    getBranchError (value) {
      this.bankTypeError = value
    },
    /**
         * @description 开户号输入框获取焦点事件
         */
    handleBankCardIdBlur () {
      if (this.applyForm.fBankAccount && /^\d{16,19}$/.test(this.applyForm.fBankAccount)) {
        this.lumhBankCardId = this.applyForm.fBankAccount
      }
    },
    // 输入发票抬头模糊查询
    remoteMethod (query, cb) {
      this.txt = query
      this.options = []
      if (query.length > 1) {
        let param = {
          keyword: query
        }
        param = qs.stringify(param)
        dimQuery(param).then(data => {
          if (data.error_code === '0') {
            const res = data.data
            if (res && res.length > 0) {
              this.options = res.map(item => {
                return {
                  value: item.name,
                  number: item.creditNo
                }
              })
            } else {
              this.$message({
                showClose: true,
                message: '暂无数据，请使用纳税人识别号精确查询',
                type: 'error'
              })
              this.applyForm.fInvoiceTitle = this.txt
              this.options = []
            }
          } else {
            this.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
            this.options = []
          }
          cb(this.options)
        })
      } else {
        this.options = []
        cb(this.options)
      }
    },
    // 精确查询
    accurateQuery () {
      if (this.applyForm.fTaxpayerNum) {
        let param = {
          creditCode: this.applyForm.fTaxpayerNum
        }
        param = qs.stringify(param)
        this.searchLoading = true
        accurateQuery(param).then(data => {
          this.searchLoading = false
          if (data.error_code === '0') {
            if (data.data) {
              const res = data.data
              this.applyForm.fInvoiceTitle = res.name
              this.applyForm.fRegisterAddress = res.address
              this.applyForm.fPhone = res.tel
              this.applyForm.fBankAccount = res.bankaccount
              this.applyForm.fBankName = res.bank
              this.handleAddressChange(this.applyForm.fRegisterAddress)
              this.$refs.applyForm.clearValidate()
            } else {
              this.$message({
                showClose: true,
                message: '查无记录',
                type: 'success'
              })
            }
          } else {
            this.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
          }
        })
      } else {
        this.$message({
          showClose: true,
          message: '请先输入纳税人识别号',
          type: 'error'
        })
      }
    },
    handleSelect (item) {
      this.applyForm.fTaxpayerNum = item.number
      this.accurateQuery()
    },
    handlePhoneChange (phone) {
      if (phone && phone.length > 20) {
        phone = phone.substr(0, 20)
        this.$message({
          showClose: true,
          message: '登记电话最长为20个字符',
          type: 'warning'
        })
      }
      this.applyForm.fPhone = phone
    },
    handleAddressChange (address) {
      this.needIntercept = false
      if (address.replace(/[\u4E00-\u9FA5]/g, '01').length > 80) {
        this.needIntercept = true
        let index = 0
        let len = 0
        let interceptAddress = ''
        while (len < 80) {
          if ((address.charCodeAt(index) & 0xff00) !== 0) {
            if (len === 79) {
              break
            } else {
              len++
            }
          }
          interceptAddress += address[index]
          index++
          len++
        }
        this.interceptAddress = interceptAddress
      }
    },
    getLastApplyRecord () {
      let param = {
        queryFMerchantId: this.selectedMerchantId,
        FInvoiceType: this.applyForm.fInvoiceType
      }
      param = qs.stringify(param)
      this.searchLoading = true
      getLastApplyRecord(param).then(data => {
        this.searchLoading = false
        if (data.result_cde === '200') {
          if (data.data) {
            const res = data.data
            this.applyForm.fInvoiceTitle = res.fInvoiceTitle
            this.applyForm.fTaxpayerNum = res.fTaxpayerNum
            this.applyForm.fRegisterAddress = res.fRegisterAddress
            this.applyForm.fPhone = res.fPhone
            this.applyForm.fBankAccount = res.fBankAccount
            this.applyForm.fBankName = res.fBankName
            this.applyForm.fRemark = res.fRemark
            this.applyForm.fMessage = res.fMessage
            if (this.applyForm.fInvoiceType === 0) {
              this.applyForm.fReceivePhone = res.fReceivePhone
              this.applyForm.fReceiveEmail = res.fReceiveEmail
            } else {
              this.applyForm.fPhone = res.fPhone
              this.applyForm.fTaxpayerPic = res.fTaxpayerPic
            }
            this.applyForm.fRegisterAddress && this.handleAddressChange(this.applyForm.fRegisterAddress)
            this.$refs.applyForm.clearValidate()
          } else {
            this.$message({
              showClose: true,
              message: '查无记录',
              type: 'success'
            })
          }
        } else {
          this.$message({
            showClose: true,
            message: data.result_msg,
            type: 'error'
          })
        }
      })
    },
    setModuleInfo (target, val) {
      for (const item in target) {
        target[item] = val[item] ? val[item] : target[item]
      }
    },
    searchSub () {
      this.subjectSearchLoading = true
      listAutoInvoiceMulti({
        FMerchantId: this.applyForm.fMerchantId,
        FFeeType: this.applyForm.fFeeType,
        FId: this.applyForm.fInvoiceId.length === 0 ? '' : this.applyForm.fInvoiceId[0] || ''
      }).then(res => {
        this.subjectSearchLoading = false
        if (res.error_code === '0') {
          this.sameSubjectList = res.data.merchants.map((item) => {
            return {
              key: item.fMerchantId,
              label: `${item.fMerchantId}/${item.shopTypeStr}/${item.fMerchantName}`
            }
          })
          this.applyForm.multiMerchantIdString = res.data.exsits.map(item => item.fMerchantId)
          if (res.data.merchants.length === 0 && res.data.exsits.length === 0) {
            this.$message({
              type: 'warning',
              message: '当前商户无同主体商户，请选择新增配置',
              showClose: true
            })
          }
        } else {
          this.$message({
            type: 'error',
            message: res.error_msg,
            showClose: true
          })
        }
      })
    },
    clearSamesubjectList (type) {
      if (this.sameSubjectList.length === 0) return
      this.sameSubjectList = []
      this.applyForm.multiMerchantIdString = []
      if (type === 'feeType') {
        this.searchSub()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.btm-action {
    margin-top: 20px;
    text-align: center;
}
.form-input {
    width: 450px;
}
.form-flex-item {
    margin-right: 5px;
}
.form-flex-item .form-input{
    width: 200px;
}
.submitBtn{
    display: block;
    margin: 20px auto;
}
.ml120{
  margin-left:120px;
}
.tips {
  margin: 0 0 20px 120px;
  color: red;
  font-size: 16px;
  font-weight: bold;
}
.grey {
    color:#C0C4CC
}
.searchLink {
  padding-left: 4px;
  text-decoration: underline;
  color: #606266;
  cursor: pointer;
}

/deep/ .el-transfer-panel {
  width: 280px;
}
.transfer {
  /deep/ .el-button {
    display: block !important;
    margin-left: 0 !important;
  }
}
</style>
